const BASE_URL = "https://api.example.com";

export default BASE_URL;